import "../fontawesome.js";
import LocaleWrapper from "../components/locale/LocaleWrapper.js";
import { makeStyles } from "@material-ui/core/styles";
import PageTile from "../layout/PageTile.js";
import Products from "../components/Products.js";
import React from "react";
import Team from "../components/Team.js";
import Welcome from "../components/Welcome";
import withRoot from "../withRoot.js";

import Layout from "../components/layout";
import SEO from "../components/seo";

const useStyles = makeStyles(() => ({
    main: {
        backgroundColor: "#fff"
    }
}));

const IndexPage = ({ locale }) => {
    const classes = useStyles();
    return (
        <LocaleWrapper locale={locale}>
            <div className={classes.main}>
                <Layout>
                    <SEO
                        title="Isyflow"
                        keywords={[
                            `isyflow`,
                            `e-learning`,
                            `class management`,
                            `lms`,
                            `course management`,
                            `vocational training`
                        ]}
                    />
                    <PageTile backgroundColor="#fff" verticalPadding={6}>
                        <Welcome />
                    </PageTile>
                    <PageTile backgroundColor="#eee" verticalPadding={8}>
                        <Products />
                    </PageTile>
                    <PageTile backgroundColor="primary" verticalPadding={8}>
                        <Team />
                    </PageTile>
                </Layout>
            </div>
        </LocaleWrapper>
    );
};

export default withRoot(IndexPage);
